export interface Produto {
  id: string;
  nomeRazao: string;
  documento: string;
  valor: string;
  valorNumerico: number;
}

export interface SecaoAquisicao {
  titulo: string;
  produtosCnpj: Produto[];
  produtosCpf: Produto[];
}

export const createDefaultSections = (): SecaoAquisicao[] => [
  {
    titulo: 'Aquisições com Recurso PNAE Federal',
    produtosCnpj: [],
    produtosCpf: []
  },
  {
    titulo: 'Aquisições com Recurso do Governo do Estado',
    produtosCnpj: [],
    produtosCpf: []
  },
  {
    titulo: 'Aquisições com Recurso da Prefeitura',
    produtosCnpj: [],
    produtosCpf: []
  }
];

export const buildSectionsFromCifa = (cifa: any): SecaoAquisicao[] => [
  {
    titulo: 'Aquisições com Recurso PNAE Federal',
    produtosCnpj: cifa.aquisicoes_pnae_federal_detalhamento?.cnpj?.map((p: any, index: number) => ({
      id: `pnae-cnpj-${index}-${p.nomeRazao.slice(0, 3)}`,
      nomeRazao: p.nomeRazao,
      documento: p.cnpj ?? '',
      valor: p.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorNumerico: p.valor
    })) ?? [],
    produtosCpf: cifa.aquisicoes_pnae_federal_detalhamento?.cpf?.map((p: any, index: number) => ({
      id: `pnae-cpf-${index}-${p.nomeRazao.slice(0, 3)}`,
      nomeRazao: p.nomeRazao,
      documento: p.cpf ?? '',
      valor: p.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorNumerico: p.valor
    })) ?? []
  },
  {
    titulo: 'Aquisições com Recurso do Governo do Estado',
    produtosCnpj: cifa.aquisicoes_governo_estado_detalhamento?.cnpj?.map((p: any, index: number) => ({
      id: `estado-cnpj-${index}-${p.nomeRazao.slice(0, 3)}`,
      nomeRazao: p.nomeRazao,
      documento: p.cnpj ?? '',
      valor: p.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorNumerico: p.valor
    })) ?? [],
    produtosCpf: cifa.aquisicoes_governo_estado_detalhamento?.cpf?.map((p: any, index: number) => ({
      id: `estado-cpf-${index}-${p.nomeRazao.slice(0, 3)}`,
      nomeRazao: p.nomeRazao,
      documento: p.cpf ?? '',
      valor: p.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorNumerico: p.valor
    })) ?? []
  },
  {
    titulo: 'Aquisições com Recurso da Prefeitura',
    produtosCnpj: cifa.aquisicoes_prefeitura_detalhamento?.cnpj?.map((p: any, index: number) => ({
      id: `prefeitura-cnpj-${index}-${p.nomeRazao.slice(0, 3)}`,
      nomeRazao: p.nomeRazao,
      documento: p.cnpj ?? '',
      valor: p.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorNumerico: p.valor
    })) ?? [],
    produtosCpf: cifa.aquisicoes_prefeitura_detalhamento?.cpf?.map((p: any, index: number) => ({
      id: `prefeitura-cpf-${index}-${p.nomeRazao.slice(0, 3)}`,
      nomeRazao: p.nomeRazao,
      documento: p.cpf ?? '',
      valor: p.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorNumerico: p.valor
    })) ?? []
  }
];

export const resolveInitialSections = (cifa: any, localStorageItem?: string | null): SecaoAquisicao[] => {
  try {
    const secoesFromBackend = buildSectionsFromCifa(cifa);
    const hasBackendData = secoesFromBackend.some(secao =>
      secao.produtosCnpj.length > 0 || secao.produtosCpf.length > 0
    );

    if (hasBackendData) return secoesFromBackend;

    if (cifa?.uuid && localStorageItem) {
      const parsed = JSON.parse(localStorageItem);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch (e) {
    // keep default on error
  }

  return createDefaultSections();
};

export const convertToApiFormat = (secao: SecaoAquisicao) => ({
  cnpj: secao.produtosCnpj.map(p => ({
    nomeRazao: p.nomeRazao,
    cnpj: p.documento.replace(/\D/g, ''),
    valor: p.valorNumerico
  })),
  cpf: secao.produtosCpf.map(p => ({
    nomeRazao: p.nomeRazao,
    cpf: p.documento.replace(/\D/g, ''),
    valor: p.valorNumerico
  }))
});

export const extractYearFromPath = (pathname: string, defaultYear = 2026) => {
  const regex = /cifa-(\d{4})/;
  const match = regex.exec(pathname);
  return match ? Number(match[1]) : defaultYear;
};
